import { InteractionType } from "@/common/types";
import {
	parkEmail,
	parkWhatsApp,
	parkWebChat,
	unParkEmail,
	unParkWhatsApp,
	unParkWebChat,
} from "@/repository/queryFns";

export const parkTextInteraction = (
	currentInteractionId: string,
	type: InteractionType | undefined
) => {
	switch (type) {
		case InteractionType.Email:
			parkEmail(currentInteractionId);
			break;
		case InteractionType.WhatsApp:
			parkWhatsApp(currentInteractionId);
			break;
		case InteractionType.Webchat:
			parkWebChat(currentInteractionId);
			break;
		default:
			break;
	}
};

export const unParkTextInteraction = (
	currentInteractionId: string,
	type: InteractionType | undefined
) => {
	switch (type) {
		case InteractionType.Email:
			return unParkEmail(currentInteractionId);
		case InteractionType.WhatsApp:
			return unParkWhatsApp(currentInteractionId);
		case InteractionType.Webchat:
			return unParkWebChat(currentInteractionId);
		default:
			return Promise.resolve(null);
	}
};
